<script setup lang="ts">
  import { defineEmits, defineProps, ref, watch } from 'vue';

  const props = defineProps({
    modelValue: {
      type: String,
      default: '',
    },
  });

  const emit = defineEmits(['update:modelValue']);

  const localValue = ref(props.modelValue);

  watch(
    () => props.modelValue,
    (newValue) => {
      localValue.value = newValue;
    }
  );

  function updateValue(value: string) {
    localValue.value = value;
    emit('update:modelValue', value);
  }

  function clearInput() {
    updateValue('');
  }
</script>

<template>
  <div class="relative w-full">
    <input
      v-model="localValue"
      @input="updateValue($event.target.value)"
      type="text"
      placeholder="Enter URL"
      class="w-full px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    />

    <button
      v-if="localValue"
      @click="clearInput"
      class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        />
      </svg>
    </button>
  </div>
</template>
